import { useSelector } from "react-redux";
import { selectPartner } from "../../store/partnerStore";
import { resolvePartnerSync } from "../../utils/partner";
import { isV2Enabled } from "../registry";

// Suppresses a legacy route header when the given screen is V2-enabled for the current partner
// (V2 screens render their own ScreenHeader). Non-V2 partners render the children unchanged.
// resolvePartnerSync so the decision is right on the first paint, before setPartner lands.
function LegacyHeaderGate({ screen, children }) {
  const partner = resolvePartnerSync(useSelector(selectPartner));
  return isV2Enabled(screen, partner) ? null : children;
}

export default LegacyHeaderGate;
